import axios from 'axios'
import getHeaders from '../../helpers/headers'
import config from '../../../constants/endpoints.js'
const {
  endpoints: {
    plugins: { passengers: url },
  },
} = config

/**
 * Get all passengers from user.
 *
 * @param {String} params.userId Id of the user in the database
 */
const getPassengers = (params) => axios.get(url, { headers: getHeaders(true), params })

/**
 * Add new passenger to user.
 *
 * @param {String} params.userId Id of the user in the database
 * @param {String} passenger Passenger data to add
 */
const addPassenger = (params, passenger) => axios.post(url, { passenger }, { headers: getHeaders(true), params })

/**
 * Update passenger from user.
 *
 * @param {String} params.userId Id of the user in the database
 * @param {String} passenger Passenger data to add
 */
const updatePassenger = (params, passenger) => axios.put(url, { passenger }, { headers: getHeaders(true), params })

/**
 * Delete passenger from user.
 *
 * @param {String} params.userId Id of the user in the database
 * @param {String} params.passengerId Id of the passenger to delete
 */
const deletePassenger = (params) => axios.delete(url, { headers: getHeaders(true), params })

export default { getPassengers, addPassenger, updatePassenger, deletePassenger }
